import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Star';
import MakeFavoriteIcon from '@material-ui/icons/StarBorder';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import * as actions from '../../../../state';
import * as events from '../../../../events';

const messages = defineMessages({
  FAVORITE_BOARD: {
    id: 'FAVORITE_BOARD',
    defaultMessage: 'Unfavorite board',
  },
  MAKE_FAVORITE_BOARD: {
    id: 'MAKE_FAVORITE_BOARD',
    defaultMessage: 'Favorite board',
  },
  FAVORITE_FAILED: {
    id: 'FAVORITE_FAILED',
    defaultMessage: 'Could not successfully favorite this board.',
  },
});

function FavoriteBtn({ intl }) {
  const dispatch = useDispatch();

  const board = useSelector(actions.readStateBoard);
  const boardList = useSelector(actions.readStateBoardList);

  const favoriteBoard = () => {
    const updatedBoardList = boardList?.map((b) => {
      // update favorite flag client-side to provide immediate user feedback
      if (b.id === board.id) {
          b.favorite = !b.favorite; // eslint-disable-line
      }

      return b;
    });

    dispatch(actions.setBoardList(updatedBoardList));
    dispatch(events.favoriteBoard(board, intl, messages));
  };

  // read this board from the boardList, which is where the favorite flag will be found
  const boardListBoard = boardList?.find((b) => b.id === board.id);
  const isFavorited = boardListBoard ? boardListBoard?.favorite : false;

  return (isFavorited
    ? (
      <Tooltip disableFocusListener title={<FormattedMessage {...messages.FAVORITE_BOARD} />}>
        <IconButton onClick={favoriteBoard}>
          <FavoriteIcon />
        </IconButton>
      </Tooltip>
    )
    : (
      <Tooltip disableFocusListener title={<FormattedMessage {...messages.MAKE_FAVORITE_BOARD} />}>
        <IconButton onClick={favoriteBoard}>
          <MakeFavoriteIcon />
        </IconButton>
      </Tooltip>
    )
  );
}

export default injectIntl(FavoriteBtn);
